export default function Logo({ size = 36 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id="coinGrad" cx="38%" cy="35%" r="65%">
          <stop offset="0%"   stopColor="#FFE066" />
          <stop offset="55%"  stopColor="#F5A800" />
          <stop offset="100%" stopColor="#C47D00" />
        </radialGradient>
        <radialGradient id="innerGrad" cx="40%" cy="38%" r="60%">
          <stop offset="0%"   stopColor="#FFF0A0" />
          <stop offset="100%" stopColor="#D98F00" />
        </radialGradient>
      </defs>

      {/* Coin shadow */}
      <ellipse cx="18.5" cy="19.5" rx="14" ry="13.5" fill="rgba(0,0,0,0.18)" />

      {/* Coin body */}
      <circle cx="18" cy="18" r="14" fill="url(#coinGrad)" />

      {/* Coin rim (ring) */}
      <circle cx="18" cy="18" r="14" stroke="#A06800" strokeWidth="0.8" fill="none" />

      {/* Inner circle engraving */}
      <circle cx="18" cy="18" r="11" fill="url(#innerGrad)" />
      <circle cx="18" cy="18" r="11" stroke="#C47D00" strokeWidth="0.5" fill="none" />

      {/* Euro sign */}
      <text
        x="18"
        y="23"
        textAnchor="middle"
        fontSize="13"
        fontWeight="700"
        fontFamily="Georgia, serif"
        fill="#7A4800"
        style={{ userSelect: 'none' }}
      >
        €
      </text>

      {/* Shine highlight */}
      <ellipse cx="13.5" cy="12.5" rx="3.5" ry="2" fill="rgba(255,255,255,0.28)" transform="rotate(-30 13.5 12.5)" />
    </svg>
  );
}
